module.exports = __webpack_public_path__ + "static/media/contact_icon.c34d759f.svg";